module.exports = __webpack_public_path__ + "img/zs8.eb5b2450.png";